import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

export default [
  // LOGIN
  {
    name: 'start',
    path: '/',
    meta: {
      title: Vue.t('generic.login.title'),
      authorize: false
    },
    component: (resolve) => {
      require(['../components/Login.vue'], resolve)
    }
  },
  {
    name: 'login',
    path: '/login',
    meta: {
      title: Vue.t('generic.login.title'),
      authorize: false
    },
    component: (resolve) => {
      require(['../components/Login.vue'], resolve)
    }
  },
  {
    name: 'logout',
    path: '/logout',
    meta: {
      title: Vue.t('generic.login.title'),
      authorize: false
    },
    component: (resolve) => {
      require(['../components/Login.vue'], resolve)
    }
  },
  // GENERIC
  {
    name: 'generic.error.ErrorPage',
    path: '/error',
    meta: {
      title: Vue.t('generic.errors.title'),
      authorize: false
    },
    component: (resolve) => {
      require(['../components/generic/error/ErrorPage.vue'], resolve)
    }
  },
  // UNITS
  {
    name: 'management.unit',
    path: '/unit/overview/:uuid?',
    meta: {
      title: Vue.t('management.unit.titles.overview'),
      sidemenu: true,
      prefix: 'UNI_'
    },
    component: (resolve) => {
      require(['../components/management/unit/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.unit.create',
    path: '/unit/create',
    meta: {
      title: Vue.t('management.unit.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/unit/Update.vue'], resolve)
    }
  },
  {
    name: 'management.unit.read',
    path: '/unit/read/:uuid',
    meta: {
      title: Vue.t('management.unit.titles.read'),
      sidemenu: true,
      actionButtonText: 'Read'
    },
    component: (resolve) => {
      require(['../components/management/unit/Read.vue'], resolve)
    },
    props: true
  },
  {
    name: 'management.unit.readsettings',
    path: '/unit/readsettings/:uuid',
    meta: {
      title: Vue.t('management.unit.titles.readsettings'),
      sidemenu: true,
      actionButtonText: 'Read settings',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/unit/Update.vue'], resolve)
    }
  },
  {
    name: 'management.unit.update',
    path: '/unit/update/:uuid',
    meta: {
      title: Vue.t('management.unit.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/unit/Update.vue'], resolve)
    }
  },
  {
    name: 'management.unit.preview',
    path: '/unit/preview/:uuid',
    meta: {
      title: Vue.t('management.unit.titles.preview'),
      actionButtonText: 'Preview',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/unit/Update.vue'], resolve)
    }
  },
  {
    name: 'management.unit.inventory',
    path: '/unit/inventory/:uuid',
    meta: {
      title: Vue.t('management.unit.titles.inventory'),
      actionButtonText: 'Inventory'
    },
    component: (resolve) => {
      require(['../components/management/unit/Inventory.vue'], resolve)
    }
  },
  // ORGANIZATIONS
  {
    name: 'management.organization',
    path: '/organization/overview/:uuid?',
    meta: {
      title: Vue.t('management.organization.titles.overview'),
      sidemenu: true,
      prefix: 'ORG_'
    },
    component: (resolve) => {
      require(['../components/management/organization/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.organization.create',
    path: '/organization/create',
    meta: {
      title: Vue.t('management.organization.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/organization/Update.vue'], resolve)
    }
  },
  {
    name: 'management.organization.jobs',
    path: '/organization/jobs/:uuid',
    meta: {
      title: Vue.t('management.organization.titles.jobs'),
      actionButtonText: 'Jobs'
    },
    component: (resolve) => {
      require(['../components/management/organization/Jobs.vue'], resolve)
    }
  },
  {
    name: 'management.organization.update',
    path: '/organization/update/:uuid',
    meta: {
      title: Vue.t('management.organization.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/organization/Update.vue'], resolve)
    }
  },
  {
    name: 'management.organization.readsettings',
    path: '/organization/readsettings/:uuid',
    meta: {
      title: Vue.t('management.organization.titles.readsettings'),
      sidemenu: true,
      actionButtonText: 'Read settings',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/organization/Update.vue'], resolve)
    }
  },
  // TILLS
  {
    name: 'management.till',
    path: '/till/overview/:uuid?',
    meta: {
      title: Vue.t('management.till.titles.overview'),
      sidemenu: true,
      prefix: 'TIL_'
    },
    component: (resolve) => {
      require(['../components/management/till/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.till.create',
    path: '/till/create/:uuid?',
    meta: {
      title: Vue.t('management.till.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/till/Update.vue'], resolve)
    }
  },
  {
    name: 'management.till.update',
    path: '/till/update/:uuid',
    meta: {
      title: Vue.t('management.till.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/till/Update.vue'], resolve)
    }
  },
  {
    name: 'management.till.read',
    path: '/till/read/:uuid',
    meta: {
      title: Vue.t('management.till.titles.read'),
      sidemenu: true,
      actionButtonText: 'Read',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/till/Update.vue'], resolve)
    },
    props: true
  },
  // USERS
  {
    name: 'management.user',
    path: '/user/overview/:uuid?',
    meta: {
      title: Vue.t('management.user.titles.overview'),
      sidemenu: true,
      prefix: 'USR_'
    },
    component: (resolve) => {
      require(['../components/management/user/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.user.readsettings',
    path: '/user/readsettings/:uuid',
    meta: {
      title: Vue.t('management.user.titles.readsettings'),
      sidemenu: true,
      prefix: 'USR_',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/user/Update.vue'], resolve)
    }
  },
  {
    name: 'management.user.create',
    path: '/user/create/:uuid?',
    meta: {
      title: Vue.t('management.user.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/user/Update.vue'], resolve)
    }
  },
  {
    name: 'management.user.update',
    path: '/user/update/:uuid',
    meta: {
      title: Vue.t('management.user.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/user/Update.vue'], resolve)
    }
  },
  {
    name: 'management.user.change-password',
    path: '/user/change-password',
    meta: {
      title: Vue.t('management.user.titles.changepassword'),
      actionButtonText: 'Save'
    },
    component: (resolve) => {
      require(['../components/management/user/ChangePassword.vue'], resolve)
    }
  },
  {
    name: 'management.user.change-pincode',
    path: '/user/change-pincode',
    meta: {
      title: Vue.t('management.user.titles.changepincodes'),
      actionButtonText: 'Save'
    },
    component: (resolve) => {
      require(['../components/management/user/ChangePincode.vue'], resolve)
    }
  },
  {
    name: 'management.user.update-profile',
    path: '/user/update-profile',
    meta: {
      title: Vue.t('management.user.titles.updateprofile'),
      actionButtonText: 'Save'
    },
    component: (resolve) => {
      require(['../components/management/user/UpdateProfile.vue'], resolve)
    }
  },
  {
    name: 'forgotPassword',
    path: '/forgotPassword',
    meta: {
      title: Vue.t('management.user.titles.forgotpassword'),
      authorize: false
    },
    component: (resolve) => {
      require(['../components/management/user/ForgotPassword.vue'], resolve)
    }
  },
  {
    name: 'resetPassword',
    path: '/resetPassword/:id/:token',
    meta: {
      title: Vue.t('management.user.titles.resetpassword'),
      authorize: false
    },
    component: (resolve) => {
      require(['../components/management/user/ResetPassword.vue'], resolve)
    }
  },
  // LOCATIONS
  {
    name: 'management.location',
    path: '/location/overview/:uuid?',
    meta: {
      title: Vue.t('management.location.titles.overview'),
      sidemenu: true,
      prefix: 'LOC_'
    },
    component: (resolve) => {
      require(['../components/management/location/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.location.create',
    path: '/location/create',
    meta: {
      title: Vue.t('management.location.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/location/Update.vue'], resolve)
    }
  },
  {
    name: 'management.location.readsettings',
    path: '/location/readsettings/:uuid',
    meta: {
      title: Vue.t('management.location.titles.readsettings'),
      sidemenu: true,
      actionButtonText: 'Read settings',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/location/Update.vue'], resolve)
    }
  },
  {
    name: 'management.location.update',
    path: '/location/update/:uuid',
    meta: {
      title: Vue.t('management.location.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/location/Update.vue'], resolve)
    }
  },
  // MIXES
  {
    name: 'management.mix',
    path: '/mix/overview/:uuid?',
    meta: {
      title: Vue.t('management.mix.titles.overview'),
      actionButtonText: 'Overview',
      sidemenu: true,
      prefix: 'MIX_'
    },
    component: (resolve) => {
      require(['../components/management/mix/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.mix.create',
    path: '/mix/create/:uuid?',
    meta: {
      title: Vue.t('management.mix.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/mix/Update.vue'], resolve)
    }
  },
  {
    name: 'management.mix.update',
    path: '/mix/edit/:uuid',
    meta: {
      title: Vue.t('management.mix.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/mix/Update.vue'], resolve)
    }
  },
  {
    name: 'management.mix.read',
    path: '/mix/read/:uuid',
    meta: {
      title: Vue.t('management.mix.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/mix/Read.vue'], resolve)
    }
  },
  {
    name: 'management.notification.read',
    path: '/notifications/read/:unitUuid/:index',
    meta: {
      title: Vue.t('management.notification.titles.read'),
      actionButtonText: 'Read'
    },
    component: (resolve) => {
      require(['../components/management/notification/Read.vue'], resolve)
    }
  },
  // UNIT ROLES
  // {
  //   name: 'management.unitRoles',
  //   path: '/unit-roles/overview/:uuid?',
  //   meta: {
  //     title: Vue.t('management.unitRoles.titles.overview'),
  //     sidemenu: true,
  //     prefix: 'UNI_'
  //   },
  //   component: (resolve) => {
  //     require(['../components/management/unitroles/Overview.vue'], resolve)
  //   }
  // },
  // {
  //   name: 'management.unitRoles.create',
  //   path: '/unit-roles/create',
  //   meta: {
  //     title: Vue.t('management.unitRoles.titles.create'),
  //     actionButtonText: 'Create'
  //   },
  //   component: (resolve) => {
  //     require(['../components/management/unitroles/Update.vue'], resolve)
  //   }
  // },
  // {
  //   name: 'management.unitRoles.update',
  //   path: '/unit-roles/edit/:id',
  //   meta: {
  //     title: Vue.t('management.unitRoles.titles.update'),
  //     actionButtonText: 'Update'
  //   },
  //   component: (resolve) => {
  //     require(['../components/management/unitroles/Update.vue'], resolve)
  //   }
  // },
  // REPORT
  {
    name: 'management.report',
    path: '/report/overview',
    meta: {
      title: Vue.t('management.report.titles.overview'),
      actionButtonText: 'createReport',
      prefix: 'REP_'
    },
    component: (resolve) => {
      require(['../components/management/report/Overview.vue'], resolve)
    }
  },
  // WORKFLOW
  {
    name: 'management.cit',
    path: '/cit/overview/:uuid?',
    meta: {
      title: Vue.t('management.cit.titles.overview'),
      sidemenu: true,
      prefix: 'SET_'
    },
    component: (resolve) => {
      require(['../components/management/cit/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.cit.create',
    path: '/cit/create',
    meta: {
      title: Vue.t('management.cit.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/cit/Update.vue'], resolve)
    }
  },
  {
    name: 'management.cit.readsettings',
    path: '/cit/readsettings/:uuid',
    meta: {
      title: Vue.t('management.cit.titles.readsettings'),
      sidemenu: true,
      actionButtonText: 'Read settings',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/cit/Update.vue'], resolve)
    }
  },
  {
    name: 'management.cit.update',
    path: '/cit/update/:uuid',
    meta: {
      title: Vue.t('management.cit.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/cit/Update.vue'], resolve)
    }
  },
  // DEPARTMENTS
  {
    name: 'management.department',
    path: '/department/overview/:uuid?',
    meta: {
      title: Vue.t('management.department.titles.overview'),
      sidemenu: true,
      prefix: 'DEP_'
    },
    component: (resolve) => {
      require(['../components/management/department/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.department.create',
    path: '/department/create',
    meta: {
      title: Vue.t('management.department.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/department/Update.vue'], resolve)
    }
  },
  {
    name: 'management.department.preview',
    path: '/department/preview/:uuid',
    meta: {
      title: Vue.t('management.department.titles.preview'),
      actionButtonText: 'Preview',
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/department/Update.vue'], resolve)
    }
  },
  {
    name: 'management.department.update',
    path: '/department/update/:uuid',
    meta: {
      title: Vue.t('management.department.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/department/Update.vue'], resolve)
    }
  },
  // SOFTWARE SETTINGS
  {
    name: 'management.softwaresettings',
    path: '/softwaresettings/overview/',
    meta: {
      title: Vue.t('management.softwaresettings.titles.overview'),
      sidemenu: true,
      prefix: 'SET_'
    },
    component: (resolve) => {
      require(['../components/management/softwaresettings/Overview.vue'], resolve)
    }
  },
  {
    name: 'management.softwaresettings.create',
    path: '/softwaresettings/create',
    meta: {
      title: Vue.t('management.softwaresettings.titles.create'),
      actionButtonText: 'Create'
    },
    component: (resolve) => {
      require(['../components/management/softwaresettings/Update.vue'], resolve)
    }
  },
  {
    name: 'management.softwaresettings.update',
    path: '/softwaresettings/update/:orgUuid/:unitTypeUuid',
    meta: {
      title: Vue.t('management.softwaresettings.titles.update'),
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/softwaresettings/Update.vue'], resolve)
    }
  },
  {
    name: 'management.softwaresettings.readsettings',
    path: '/softwaresettings/readsettings/:orgUuid/:unitTypeUuid',
    meta: {
      title: Vue.t('management.softwaresettings.titles.readsettings'),
      sidemenu: true,
      readOnly: true
    },
    component: (resolve) => {
      require(['../components/management/softwaresettings/Update.vue'], resolve)
    }
  },
  {
    name: 'management.transaction.read',
    path: '/transaction/read/:unitUuid/:uuid',
    meta: {
      title: Vue.t('management.transaction.read'),
      actionButtonText: 'Read'
    },
    component: (resolve) => {
      require(['../components/management/transaction/Read.vue'], resolve)
    }
  },
  {
    name: 'management.unit.campaign.read',
    path: '/cit/read/:uuid/:groupedCampaigns',
    meta: {
      title: Vue.t('management.unit.campaign.read'),
      actionButtonText: 'Read'
    },
    component: (resolve) => {
      require(['../components/management/cit/Read.vue'], resolve)
    }
  },
  // SOFTWARE SETTINGS
  {
    name: 'management.adminsettings',
    path: '/adminsettings/overview/',
    meta: {
      title: Vue.t('management.adminsettings.titles.overview'),
      sidemenu: true,
      prefix: 'ADM_',
      actionButtonText: 'Update'
    },
    component: (resolve) => {
      require(['../components/management/adminsettings/Overview.vue'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/menu.js